import { createRoot } from "react-dom/client";
import { LanguageProvider } from "./contexts/LanguageContext";
import App from "./App.tsx";
import "./index.css";

// Deze website is gestopt: verwijs alle pagina's door naar www.newdata.nl
window.location.replace("https://www.newdata.nl/");

createRoot(document.getElementById("root")!).render(
  <LanguageProvider>
    <App />
  </LanguageProvider>
);
